import { Flex, IconButton, Text, useHover } from "@huub-web/ui";
import { mergeClasses, padNumber } from "@huub-web/utils";
import { useTranslation } from "react-i18next";

import {
  buttonStyle,
  containerStyle,
  iconButtonStyle,
  indexTextStyle,
  titleStyle,
} from "./IndexItem.css";
import { focusVisibleOffset } from "@huub-web/ui/theme/css/focusVisible.css";

export type IndexItemProps = {
  index: number;
  title: string;
  subtitle?: string;
  onClick: () => void;
  disabled?: boolean;
  noData?: boolean;
  loading?: boolean;
  positiveCount?: boolean;
};

export const IndexItem = ({
  index,
  title,
  subtitle,
  onClick,
  disabled,
  loading,
  noData,
  positiveCount,
}: IndexItemProps) => {
  const { t } = useTranslation();
  const { hasHover, handleEnter, handleLeave } = useHover();

  return (
    <li
      className={containerStyle({ disabled, loading, noData, positiveCount })}
      {...(disabled ? { "aria-disabled": true } : {})}
    >
      <Flex
        as="button"
        align="flex-start"
        justify="flex-end"
        onClick={onClick}
        className={mergeClasses(buttonStyle(), focusVisibleOffset)}
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
        disabled={disabled}
        grow
      >
        <Text
          shrink={false}
          color="currentColor25"
          variant="displayM"
          className={indexTextStyle}
        >
          {padNumber(index)}
        </Text>
        <Flex
          direction="column"
          align="flex-start"
          justify="center"
          grow
          gap="xxs2"
        >
          <Text
            variant="displayS"
            className={titleStyle}
            color={loading || noData ? "currentColor25" : undefined}
          >
            {title}
          </Text>
          {(subtitle || loading) && (
            <Text
              color={loading ? "currentColor25" : "currentColor50"}
              variant="bodyM"
              italic={loading || noData}
            >
              {loading
                ? t("analysis.loading")
                : noData
                  ? t("analysisIndex.noData")
                  : subtitle}
            </Text>
          )}
        </Flex>
        <IconButton
          as="div"
          // icon={loading ? "loading" : "chevronRight"}
          icon="chevronRight"
          variant="opaque"
          // border={loading ? "none" : "default"}
          border="default"
          size="s"
          rounded
          className={iconButtonStyle}
          active={hasHover}
          // iconAnimation={loading ? "rotation" : undefined}
        />
      </Flex>
    </li>
  );
};
